const GetYoutubeIDFromShorts = (ShortsURL) => {

    var regExp = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/;
    var match = ShortsURL.match(regExp);

    if (match) 
    {
        return match[1];
    } 
    else 
    {
        return '';
    }
}

export default (url) => {
    var regExp = /^(?:(?:https?:)?\/\/)?(?:(?:www|m)\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([a-zA-Z0-9_-]{11})/;
    var match = url.match(regExp);
    if (match) 
    {
        return match[1];
    } 
    else 
    {
        return '';
    }
}

export {GetYoutubeIDFromShorts}